import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AccordionItemComponent,
  AccordionItemDividerDirective,
  AccordionItemTitleDirective,
} from './accordion-item/accordion-item.component';
import { AccordionComponent } from './';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AccordionComponent,
    AccordionItemComponent,
    AccordionItemTitleDirective,
    AccordionItemDividerDirective,
  ],
  exports: [
    AccordionComponent,
    AccordionItemComponent,
    AccordionItemTitleDirective,
    AccordionItemDividerDirective,
  ],
})
export class AccordionModule {}
